// Phase 1A Step 34 — Sticky landing navigation.
// Port from handoff/landing-reference/app.jsx Nav component.
// On-scroll background blur via .nav-blur-on class. Hover transitions
// inline-styled to match handoff exactly.

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo.tsx";

const NAV_LINKS: ReadonlyArray<{ lbl: string; href: string }> = [
  { lbl: "Engine", href: "#agents" },
  { lbl: "Ledger", href: "#ledger" },
  { lbl: "BIG6", href: "#big6" },
  { lbl: "Features", href: "#features" },
  { lbl: "Pricing", href: "#pricing" },
  { lbl: "Login", href: "/auth" },
];

export function LandingNav(): JSX.Element {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = (): void => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`sz-l-nav ${scrolled ? "nav-blur-on" : ""}`}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        padding: "18px 0",
        zIndex: 50,
        transition: "background .25s, border-color .25s",
      }}
    >
      <div
        className="container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Logo size={22} />
        <div className="sz-l-nav-links" style={{ display: "flex", gap: 36 }}>
          {NAV_LINKS.map((l) =>
            l.href.startsWith("/") ? (
              <Link
                key={l.lbl}
                to={l.href}
                className="mono"
                style={{
                  fontSize: 11,
                  letterSpacing: "0.16em",
                  textTransform: "uppercase",
                  color: "var(--text-muted)",
                  transition: "color .15s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "var(--accent)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "var(--text-muted)";
                }}
              >
                {l.lbl}
              </Link>
            ) : (
              <a
                key={l.lbl}
                href={l.href}
                className="mono"
                style={{
                  fontSize: 11,
                  letterSpacing: "0.16em",
                  textTransform: "uppercase",
                  color: "var(--text-muted)",
                  transition: "color .15s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "var(--accent)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "var(--text-muted)";
                }}
              >
                {l.lbl}
              </a>
            ),
          )}
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <Link
            to="/daily-acca"
            style={{
              fontSize: 11,
              fontFamily: "var(--font-mono, monospace)",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              color: "var(--accent)",
              textDecoration: "none",
              padding: "8px 12px",
              border: "1px solid var(--accent)",
              borderRadius: 4,
            }}
          >
            Daily Acca <span aria-hidden="true">→</span>
          </Link>
          <Link to="/auth" className="btn btn-primary" style={{ padding: "10px 18px", fontSize: 11 }}>
            Start Free <span className="btn-arrow">→</span>
          </Link>
        </div>
      </div>
    </nav>
  );
}
